module.exports = __webpack_public_path__ + "static/media/closeCircle.1edeb1d8.svg";